import { useSelector } from 'react-redux'

import { useFlags } from '@lyrahealth-inc/shared-app-logic/src/features/flags/useFlags'

import { NP_TESTER_ROLES } from '../common/constants/appConstants'
import { hasRole } from '../common/utils/utils'
import { getAuthConfig, getAuthRoles } from '../data/auth/authSelectors'

/**
 * [ENGBEND-12942] The role config decides this for every provider but the NP testers: their config
 * opens the nav to reach the test plan, so the tab stays owned by the `npTestingPlans` flag.
 */
export const useShowClientsNav = (): boolean => {
  const { npTestingPlans } = useFlags()
  const config = useSelector(getAuthConfig)
  const roles = useSelector(getAuthRoles)

  if (config?.hideClientsNav) {
    return false
  }
  return hasRole(roles, NP_TESTER_ROLES) ? npTestingPlans : true
}
